// extracted by mini-css-extract-plugin
export default {"container":"Product_container__CKMET","products":"Product_products__B0VFv","menu":"Product_menu__vh9Mr","list":"Product_list__9sQyp","product":"Product_product__UJnFU"};